var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconConfidentiality(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.881,
    height: 50.508,
    viewBox: "0 0 37.881 50.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark-lock2-svgrepo-com",
    transform: "translate(-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5595",
    "data-name": "Path 5595",
    d: "M20.784,11.313v3.4a4.123,4.123,0,0,1,3.157,3.864V26.15c0,2.576-2.465,4.1-4.735,4.1H9.735C7.465,30.254,5,28.726,5,26.15V18.574A4.123,4.123,0,0,1,8.157,14.71v-3.4a6.313,6.313,0,0,1,12.627,0Zm-9.47,0V14.47h6.313V11.313a3.157,3.157,0,0,0-6.313,0Z",
    transform: "translate(6.47 10.784)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5596",
    "data-name": "Path 5596",
    d: "M39.881,44.194V14.205L25.676,0H8.313A6.313,6.313,0,0,0,2,6.313V44.194a6.313,6.313,0,0,0,6.313,6.313H33.567A6.313,6.313,0,0,0,39.881,44.194ZM25.676,9.47a4.735,4.735,0,0,0,4.735,4.735h6.313V44.194a3.157,3.157,0,0,1-3.157,3.157H8.313a3.157,3.157,0,0,1-3.157-3.157V6.313A3.157,3.157,0,0,1,8.313,3.157H25.676Z",
    transform: "translate(0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconConfidentiality);
export default __webpack_public_path__ + "static/media/icon-confidentiality.36d8a0e25135af89c5681c00342c1cae.svg";
export { ForwardRef as ReactComponent };